import { render, staticRenderFns } from "./PetInsurancesClaim.vue?vue&type=template&id=20222150&"
import script from "./PetInsurancesClaim.vue?vue&type=script&lang=js&"
export * from "./PetInsurancesClaim.vue?vue&type=script&lang=js&"
import style0 from "./PetInsurancesClaim.vue?vue&type=style&index=0&id=20222150&prod&lang=scss&scrop=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports